import { render } from "./PagoModal.vue?vue&type=template&id=bec26874"
import script from "./PagoModal.vue?vue&type=script&lang=js"
export * from "./PagoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__